module.exports = __webpack_public_path__ + "static/c6-61f95be4cbc95450654e77879c309246.jpg";